import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import BackIconWhite from '../assets/icons/BackIconWhite.png';
import BEBanner from '../assets/images/BEBanner.png';
import LCPBanner from '../assets/images/LCP_Banner_EN_3999.png';
import HindiBEBanner from '../assets/images/HindiBEBanner.png';
import HindiLCPBanner from '../assets/images/LCP_Banner_HI_3999.png';
import { sendEventsToAnalyticsSystems } from '../utils/analytics';
import DisbleImageEn from '../assets/images/lockedNewBanner_EN.png';
import EnableImageEn from '../assets/images/unlocked_bannernew.png';
import DisbleImageHI from '../assets/images/lockedNewBanner_HI.png';
import EnableImageHI from '../assets/images/unlocked_bannerHi.png';

const BreatheFreeLiveTv = () => {
  const [lang, setLang] = useState('en');
  const location = useLocation();
  const [videoUrl, setVideoUrl] = useState(null);
  const [headerTitle, setheaderTitle] = useState('');
  const [headerTitleHindi, setheaderTitleHindi] = useState('');
  const [subTitleEn, setSubTitleEn] = useState('');
  const [subTitleHi, setSubTitleHi] = useState('');
  const [channelName, setChannelName] = useState('');
  const [secondaryuuid, setSecondaryUuid] = useState('');
  const [showTimer, setShowTimer] = useState(false);
  const [landingPageid, setlandingPageid] = useState('');
  const [elapsedTime, setElapsedTime] = useState(0);
  const [countDownTime, setCountDownTime] = useState(0);
  const [showDisableBanner, setShowDisableBanner] = useState(true);
  const [timer, setTimer] = useState(0);
  const [currentDate, setCurrentDate] = useState(new Date().toDateString());
  const [timerReached, setTimerReached] = useState(false);
  const [timerActive, setTimerActive] = useState(true);
  const [quizBanner, setQuizBanner] = useState(true);
  const [hasTimerParam, setHasTimerParam] = useState(false);
  const elapsedTimeRef = useRef(elapsedTime);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const langParam = searchParams.get('lang');
    const url = searchParams.get('url');
    const headertitle_en = searchParams.get('head_title_en');
    const headertitle_hi = searchParams.get('head_title_hi');
    const subtitle_en = searchParams.get('video_title_en');
    const subtitle_hi = searchParams.get('video_title_hi');
    const channel_name = searchParams.get('channel_name');
    const secondary_uuid = searchParams.get('uuid');
    const landingPageid = searchParams.get('landing_page_id');
    const timerParam = searchParams.get('timer');
    const quiz_banner = searchParams.get('quiz_banner');

    if (langParam && ['en', 'hi'].includes(langParam.toLowerCase())) {
      setLang(langParam.toLowerCase());
    }
    setheaderTitle(headertitle_en || '');
    setheaderTitleHindi(headertitle_hi || '');
    setSubTitleEn(subtitle_en || '');
    setSubTitleHi(subtitle_hi || '');
    setChannelName(channel_name || '');
    setVideoUrl(url || '');
    setSecondaryUuid(secondary_uuid || '');
    setlandingPageid(landingPageid || '');

    if (timerParam) {
      const parsedTimer = parseInt(timerParam, 10);
      // Only set timer and related states if parsedTimer is 1 or greater
      if (parsedTimer >= 1) {
        setTimer(parsedTimer);
        setShowTimer(true);
        setHasTimerParam(true);
        setCountDownTime(parsedTimer * 60);
      } else {
        // Reset to default state if timer is less than 1
        setTimer(0);
        setShowTimer(false);
        setHasTimerParam(false);
      }
    } else {
      setTimer(0);
      setShowTimer(false);
      setHasTimerParam(false);
    }

    if (quiz_banner !== null) {
      setQuizBanner(quiz_banner === 'false');
    }
  }, [location]);

  useEffect(() => {
    const watchTimeKey = 'watchtimecomponents';
    const countUpKey = 'countuptime';
    const lastWatchDate = localStorage.getItem('lastWatchDate');
    const savedElapsedTime = localStorage.getItem('elapsedTime');
    const today = new Date().toDateString();

    if (lastWatchDate !== today) {
      // Reset everything for a new day
      localStorage.setItem('lastWatchDate', today);
      localStorage.removeItem('elapsedTime');
      localStorage.removeItem(watchTimeKey);
      localStorage.removeItem(countUpKey);
      setShowDisableBanner(true);
      setElapsedTime(0);
      setTimerReached(false);
      localStorage.setItem(countUpKey, '0');
    } else {
      // Restore state from localStorage
      if (localStorage.getItem(watchTimeKey) === 'true') {
        setShowDisableBanner(false);
        setTimerReached(true);
      }

      if (savedElapsedTime) {
        const storedElapsedTime = parseInt(savedElapsedTime || '0');
        setElapsedTime(storedElapsedTime);
        
        // Initialize countdown timer with remaining time if not already completed
        if (timer && hasTimerParam) {
          const timeRemaining = Math.max(0, timer * 60 - storedElapsedTime);
          setCountDownTime(timeRemaining);
          if (timeRemaining === 0 && !timerReached) {
            setShowDisableBanner(false);
            setTimerReached(true);
            localStorage.setItem(watchTimeKey, 'true');
          }
        }
      }
    }

    const dateCheckInterval = setInterval(() => {
      const newDate = new Date().toDateString();
      if (newDate !== currentDate) {
        // Reset everything for a new day
        setCurrentDate(newDate);
        localStorage.setItem('lastWatchDate', newDate);
        localStorage.removeItem('elapsedTime');
        localStorage.removeItem(watchTimeKey);
        localStorage.removeItem(countUpKey);
        setShowDisableBanner(true);
        setElapsedTime(0);
        setTimerReached(false);
        localStorage.setItem(countUpKey, '0');
      }
    }, 60000);

    return () => {
      clearInterval(dateCheckInterval);
    };
  }, [currentDate, timer, hasTimerParam]);
  useEffect(() => {
    elapsedTimeRef.current = elapsedTime;
  }, [elapsedTime]);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // User has left the screen - pause timers
        setTimerActive(false);
        
        // Use ref to get current value
        localStorage.setItem('elapsedTime', elapsedTimeRef.current.toString());
        localStorage.setItem('countuptime', elapsedTimeRef.current.toString());
      } else {
        // User has returned to the screen - resume timers
        setTimerActive(true);
      }
    };

    const handleBeforeUnload = () => {
      localStorage.setItem('elapsedTime', elapsedTimeRef.current.toString());
      localStorage.setItem('countuptime', elapsedTimeRef.current.toString());
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []); 
  useEffect(() => {
    // Only run the timer when the component is active/visible
    if (!timerActive) return;

    const timerInterval = setInterval(() => {
      // Get latest state values
      setElapsedTime(prevElapsedTime => {
        const newElapsedTime = prevElapsedTime + 1;
        
        // Update localStorage with the new elapsed time
        localStorage.setItem('elapsedTime', newElapsedTime.toString());
        localStorage.setItem('countuptime', newElapsedTime.toString());
        
        // Update countdown time and check if timer has reached
        if (hasTimerParam && timer) {
          const newRemainingTime = Math.max(0, timer * 60 - newElapsedTime);
          setCountDownTime(newRemainingTime);
          
          if (newRemainingTime === 0 && !timerReached) {
            setShowDisableBanner(false);
            setTimerReached(true);
            localStorage.setItem('watchtimecomponents', 'true');
          }
        }
        
        return newElapsedTime;
      });
    }, 1000);

    return () => {
      clearInterval(timerInterval);
    };
  }, [timerActive, timer, timerReached, hasTimerParam]);

  const TimerDisplay = () => {
    if (!showTimer) return null;

    // For count-up timer display (for analytics)
    const upMinutes = Math.floor(elapsedTime / 60);
    const upSeconds = elapsedTime % 60;
    
    // For countdown timer display (for UI)
    const downMinutes = Math.floor(countDownTime / 60);
    const downSeconds = countDownTime % 60;

    // Only show countdown if not reached, otherwise hide timer
    if (timerReached || quizBanner === true || timer <= 0 || timer.toString() === null) return null;

    const timerText = lang === 'en' ? 'Quiz Unlocks in: ' : 'क्विज़ अनलॉक होगा: ';

    return (
      <div className="flex items-center justify-end bg-white rounded-lg py-2 px-4 shadow-md">
        <div className="text-[#6E1EE5] font-semibold">
          {timerText}
          {downMinutes}:{downSeconds < 10 ? `0${downSeconds}` : downSeconds}
        </div>
      </div>
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const channel_name = searchParams.get('channel_name');
    const payload = {
      language: lang === 'en' ? 'English' : 'Hindi',
      channel_name: channelName || channel_name || '',
    };
    sendEventsToAnalyticsSystems('LiveTV_loaded', payload, secondaryuuid);
  }, [location, lang, channelName, secondaryuuid]);

  useEffect(() => {
    let reactNativePayload = { type: 'HIDE_BACK_ARROW', key: 205 };
    window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
  }, []);

  const handleBackToHome = () => {
    let reactNativePayload = { type: 'HIDE_INTERNAL_PWA', key: 207 };
    window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
    const payload = {
      timespent: localStorage.getItem('countuptime'),
    };
    sendEventsToAnalyticsSystems('back_button_clicked', payload, secondaryuuid);
  };

  const getBanners = () => {
    const getStandardBanners = (language) => {
      if (language === 'en') {
        return [
          { name: 'BE', image: BEBanner, event: 'LiveTV_Banner_BE_Click', navigateUrl: 'breathing_exercise', isClickable: true },
          { name: 'LCP', image: LCPBanner, event: 'LiveTV_Banner_LCP_Click', navigateUrl: 'landing_page', isClickable: true },
        ];
      } else {
        return [
          { name: 'BE', image: HindiBEBanner, event: 'LiveTV_Banner_BE_Click', navigateUrl: 'breathing_exercise', isClickable: true },
          { name: 'LCP', image: HindiLCPBanner, event: 'LiveTV_Banner_LCP_Click', navigateUrl: 'landing_page', isClickable: true },
        ];
      }
    };

    const getLockUnlockBanners = (language) => {
      if (language === 'en') {
        return showDisableBanner
          ? [{ name: 'DisableBanner', image: DisbleImageEn, isClickable: false }]
          : [{
              name: 'EnableBanner',
              image: EnableImageEn,
              event: 'LiveTV_Banner_Quiz_Click',
              navigateUrl: 'landing_page',
              landingId: landingPageid,
              isClickable: true,
            }];
      } else {
        return showDisableBanner
          ? [{ name: 'DisableBanner', image: DisbleImageHI, isClickable: false }]
          : [{
              name: 'EnableBanner',
              image: EnableImageHI,
              event: 'LiveTV_Banner_Quiz_Click',
              navigateUrl: 'landing_page',
              landingId: landingPageid,
              isClickable: true,
            }];
      }
    };

    const standardBanners = getStandardBanners(lang);

    // Only show lock/unlock banners if timer is 1 or greater
    if (hasTimerParam && timer >= 1 && !quizBanner) {
      return [...getLockUnlockBanners(lang), ...standardBanners];
    } else {
      return standardBanners;
    }
  };

  const handleBannerClick = (banner) => {
    if (!banner.isClickable) return;

    let reactNativePayload = {
      key: 203,
      data: {
        navigate_url: banner.navigateUrl,
        navigate_type: 'INTERNAL',
        redirection_id: banner.landingId,
      },
    };

    if (window?.ReactNativeWebView) {
      window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
    }

    if (banner.event) {
      const payload = {
        language: lang === 'en' ? 'English' : 'Hindi',
        timespent: localStorage.getItem('countuptime'),
        landing_page_id: banner.landingId,
      };
      sendEventsToAnalyticsSystems(banner.event, payload, secondaryuuid);
    }
  };

  const getTitleToDisplay = () => {
    if (lang === 'en' && headerTitle) {
      return headerTitle;
    }
    if (lang === 'hi' && headerTitleHindi) {
      return headerTitleHindi;
    }

    return lang === 'en'
      ? "What's On Now • Live TV"
      : 'अभी क्या चल रहा है • लाइव टीवी';
  };

  const getSubtitleToDisplay = () => {
    if (lang === 'en' && subTitleEn) {
      return subTitleEn;
    }
    if (lang === 'hi' && subTitleHi) {
      return subTitleHi;
    }

    return "BreatheFree TV - 24X7";
  };

  return (
    <>
      <nav className="bg-[#6E1EE5] w-full z-20 top-0 start-0" style={{ background: 'linear-gradient(90.09deg, #6E1EE5 23.48%, #C081F8 122.36%)' }}>
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <div className="flex items-center gap-5">
            <a onClick={handleBackToHome} href="https://share.cdhl.in/kNrr">
              <img src={BackIconWhite} className="h-full" alt="Back Icon" />
            </a>
            <p className="text-xl font-semibold text-[#FFFFFF]">
              {getTitleToDisplay()}
            </p>
          </div>
        </div>
      </nav>
      <div className="flex justify-center items-center">
        <iframe
          src={videoUrl ? videoUrl : process.env.REACT_APP_BREATHEFREE_LIVE_TV}
          width="640"
          height="300"
          allowFullScreen="1"
          frameBorder="0"
        ></iframe>
      </div>
      <div className="mt-3 px-5">
        <p className="text-xl font-semibold text-[#050505]">{getSubtitleToDisplay()}</p>
      </div>
      {showTimer && hasTimerParam && timer >= 1 && !timerReached && (
        <div className="flex justify-end mt-4 px-5">
          <TimerDisplay />
        </div>
      )}
      <div className="mb-5 mt-">
        {getBanners().map((banner, index) => (
          <div
            key={banner.name}
            className={`flex justify-center px-5 items-center ${index === 0 ? '' : ''}`}
          >
            <img
              className={`w-full h-full mt-4 ${banner.isClickable ? 'cursor-pointer' : 'cursor-default'}`}
              onClick={() => banner.isClickable && handleBannerClick(banner)}
              src={banner.image}
              alt={`${banner.name} Banner`}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default BreatheFreeLiveTv;